@if (wait) {
  <div class="overlay" (click)="$event.stopPropagation()">
    <div class='loading-spinner'></div>
  </div>
}